module.exports = __webpack_public_path__ + "static/media/Max.af5f5c42.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/DynamicContent/About/peopleCompany/Max.png
// module id = 740
// module chunks = 0